import React, { Component } from 'react';
import Dialog from 'material-ui-beta/Dialog';
import Button from 'material-ui-beta/Button';
import { CircularProgress } from 'material-ui-beta/Progress';

import './DropZone.css';

class   DropZone extends Component {

    constructor(props) {
        super(props);

        this.state = {
            hovering: 0,
            showDialog: false
        }
    }

    onDragEnter = (event) => {
        this.setState({
          hovering: this.state.hovering + 1
        });
    }

    onDragOver = (event) => {
        event.preventDefault();
        return true;
    }

    onDragLeave = (event) => {
        this.setState({
            hovering:this.state.hovering - 1
        });
    }

    onDrop = (event) => {
        event.preventDefault();
        this.setState({
            hovering:0
        });

        var droppedFiles = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        var file = droppedFiles[0];

        if (this.isAcceptableFile(file)) {
            this.props.onDrop(file);
        } else {
            this.setState({
                showDialog: true
            });
        }
    }

    isAcceptableFile(file) {
        if (this.props.accepts) {
            var accepts = this.props.accepts.split(",");
            var parts = file.name.split(".");
            for (var index = 0; index < accepts.length; index++) {
                if (accepts[index].toLowerCase().replace(".","") === parts[parts.length-1].toLowerCase()) {
                    return true;
                }
            }
            return false;
        }
        return true;
    }

    handleCloseDialog = () => {
        this.setState({
            showDialog: false,
            hovering:0
        });
    }

    getContent() {
        var content = <EmptyContent onFileChanged={this.onFileChanged} accepts={this.props.accepts} />;
        if (this.state.hovering) {
            content = <HoveringContent />;
        } else if (this.props.uploading) {
            content = <UploadingContent />;
        }
        return content;
    }

    onFileChanged = (event) => {
        this.props.onDrop(event.target.files[0]);
    }

    render() {
        return (
            <div className="drop-zone-container"
                 onDragEnter={this.onDragEnter}
                 onDragOver={this.onDragOver}
                 onDragLeave={this.onDragLeave}
                 onDrop={this.onDrop}>

                <div style={{padding:"20px", display:"flex", flexGrow:"1", alignItems:"center", justifyContent:"center", height:"100%"}}>
                    {this.getContent()}
                </div>
                <Dialog
                    open={this.state.showDialog}
                    actions={[
                        <Button color="primary" onClick={this.handleCloseDialog}>OK</Button>
                    ]}
                    title="Invalid Filetype"
                    onRequestClose={this.handleCloseDialog}>
                    You can only upload these filetypes: {this.props.accepts}
                </Dialog>
            </div>
        );
    }

}

class EmptyContent extends Component {

    onChooseFileClick = () => {
        this.refs.imageInput.click();
    }

    render() {
        return (
            <div>
                <div className="drop-zone-title roboto">
                    Drag File Here
                </div>
                <div className="drop-zone-or roboto">
                    -- or --
                </div>
                <div className="flex centerBoth">
                    <Button variant="raised" color="secondary" onClick={this.onChooseFileClick}>Choose File</Button>
                </div>
                <div>
                    <input
                        ref="imageInput"
                        type="file"
                        id="image-file"
                        name="image-file"
                        accept={this.props.accepts}
                        style={{visibility: "hidden"}}
                        onChange={this.props.onFileChanged} />
                </div>
            </div>
        )
    }

}

class HoveringContent extends Component {

    render() {
        return (
            <div>
                <div className="drop-zone-title roboto">
                    <div>
                        Drop to Upload. You got this :)
                    </div>
                </div>
            </div>
        )
    }

}

class UploadingContent extends Component {

    render() {
        return (
            <div>
                <div className="drop-zone-title roboto">
                    Uploading
                </div>
                <CircularProgress size={50} />
            </div>
        )
    }

}

export default DropZone;


// WEBPACK FOOTER //
// ./src/components/dropzone/DropZone.js